export default __webpack_public_path__ + "static/media/SN1-1.94d4e048.jpg";